import { SR_API_ACTION_HITLIST_TASK_UPDATE } from 'api/actionTypes';

export default async function updateHitlistTask(
  { state, apiClient },
  { updates, hitlistTaskId, hitlistTaskListId },
) {
  const statePath = ['hitlistTask', 'list', hitlistTaskListId];

  return apiClient.postWithState({
    action: SR_API_ACTION_HITLIST_TASK_UPDATE,
    state: state,
    payload: {
      hitlistTaskId,
      updates,
    },
    onSuccess(hitlistTaskUpdated) {
      const hitlistTaskList = state.get(statePath);
      state.set(
        statePath,
        hitlistTaskList.map((hitlistTask) => {
          return hitlistTask.task.id === hitlistTaskUpdated.id
            ? {
                ...hitlistTask,
                task: hitlistTaskUpdated,
              }
            : hitlistTask;
        }),
      );
    },
  });
}
